import { useStores } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { List } from '@/components/blocks/Message/MessageList/MessageList';
import { Skeleton, YStack } from '@/components/ui';
import { useResizeObserver } from '@/hooks/useResizeObserver';

import { ProjectItemBreadcrumb } from './projects';
import { useProjectSharedChatDetail } from './use-project-shared-chat-detail';

export const ProjectSharedChatDetailScreen = observer(
  function ProjectSharedChatDetailScreen({
    projectId,
    chatId,
  }: {
    projectId: string;
    chatId: string;
  }) {
    const { projects } = useStores();
    const project = projects.getById(projectId);
    const { detail, error, isLoading } = useProjectSharedChatDetail(
      projectId,
      chatId
    );
    const [containerRef, containerRect] = useResizeObserver<HTMLDivElement>();

    return (
      <YStack className="h-full min-h-0">
        <ProjectItemBreadcrumb project={project} title={detail?.title ?? ''} />
        {isLoading && (
          <YStack className="p-4">
            <Skeleton className="h-24 rounded-lg" />
          </YStack>
        )}
        {!isLoading && error && (
          <YStack className="p-4">
            <p className="text-sm text-foreground-muted">{error}</p>
          </YStack>
        )}
        {!isLoading && !error && detail && (
          <div
            ref={containerRef}
            className="flex flex-1 min-h-0 overflow-hidden"
          >
            <List
              messages={detail.messages}
              height={containerRect.height || 400}
              threadId={chatId}
              thread={detail.thread}
            />
          </div>
        )}
      </YStack>
    );
  }
);
